import { type AxiosRequestConfig } from 'axios'

const addUserLanguage = (data: any): AxiosRequestConfig => {
  return {
    method: 'POST',
    url: '/user/info/languages/item',
    data
  }
}

export { addUserLanguage }
